import axios from 'axios';
import * as moment from 'moment';

export default {
    namespaced: true,
    state: {
        userInput: {
            listing_id: null,
            startDate: null,
            endDate: null,
            deliveryType: null,
            location: {
                id: null,
                address: '',
                postalCode: '',
                city: 'Winnipeg',
                province: 'Manitoba'
            }
        },
        listingData: null,
        loadingReceiptData: false
    },
    getters: {
        rentalPrice(state) {
            var endDate = moment(state.userInput.endDate);
            var startDate = moment(state.userInput.startDate);
            var diff = endDate.diff(startDate);
            var hours = moment.duration(diff).asHours();

            var rates = [
                { hours: 24, rate: state.listingData.dailyRate },
                ...state.listingData.rates
            ].sort((a, b) => b.hours - a.hours);

            return rates.reduce((bestRate, rate) => {
                var r = (Math.max(hours, rate.hours) / rate.hours) * rate.rate;
                return bestRate == 0 ? r : Math.min(bestRate, r);
            }, 0);
        },
        deliveryFee(state) {
            var deliveryCost = 0;
            if (state.userInput.deliveryType === 'owner_delivery') {
                deliveryCost = parseFloat(state.listingData.deliveryPrice);
            }
            if (state.userInput.deliveryType === 'tooliaba_delivery') {
                deliveryCost = state.listingData.tooliabaDeliveryPrice;
            }
            return deliveryCost;
        },
        ownerFeeTotal(state) {
            var total = 0;
            state.listingData.fees.forEach(fee => {
                total += parseFloat(fee.amount);
            });
            return total;
        },
        serviceFee(state, getters) {
            return getters.rentalPrice * 0.1;
        }
    },
    mutations: {
        resetReceiptData(state) {
            state.listingData = null;
        },
        loadReceiptData(state) {
            state.loadingReceiptData = true;
        },
        updateReceiptData(state, data) {
            state.listingData = data;
            state.loadingReceiptData = false;
        },
        updateDeliveryType(state, data) {
            state.userInput.deliveryType = data;
        },
        updateLocation(state, location) {
            state.userInput.location = location;
        },
        setDefaultDates(state) {
            state.userInput.startDate = moment()
                .add(1, 'd')
                .startOf('day')
                .set('hour', 8)
                .toJSON();
            state.userInput.endDate = moment()
                .add(2, 'd')
                .startOf('day')
                .set('hour', 22)
                .toJSON();
        },
        updateStartDate(state, startDate) {
            state.userInput.startDate = startDate;
        },
        updateEndDate(state, endDate) {
            state.userInput.endDate = endDate;
        },
        setListingId(state, listing_id) {
            state.userInput.listing_id = listing_id;
        },
        resetLocation(state) {
            state.userInput.location.id = null;
            state.userInput.location.postalCode = '';
            state.userInput.location.city = 'Winnipeg';
            state.userInput.location.province = 'Manitoba';
        }
    },
    actions: {
        getReceiptData({ commit }, listingId) {
            commit('resetReceiptData');
            commit('loadReceiptData');
            axios
                .get('/receipt-data/' + listingId)
                .then(result => {
                    commit('updateReceiptData', result.data.data);
                    commit('setListingId', result.data.data.listingId);
                })
                .catch(console.error);
        },
        postRental({ state }) {
            return axios.post('/rental', state.userInput).catch(console.error);
        }
    }
};
